<template>
  <div class="collect-page collect-card">
    <div class="mains-content">
      <div class="page-left">
        <div class="member-box"><member ref="memberSearch" :mobile="formMobile" @handleUser="memberChange"></member></div>
        <div class="right-box">
          <div v-if="listSelected.length == 0 ? true:false" class="right-box-empty">
            <div class="right-box-empty-img">
              <img src="../../../assets/images/new/empty.png" alt="">
              <div class="color999 fontSize16 mt30">点击右侧卡片，进行划卡</div>
            </div>
          </div>
          <div v-else>
            <p class="shoping-titles">消费明细</p>
            <div class="contents-body">
            <el-row class="tables-title">
              <el-col :span="active == 'groupCard' ? 6:11" class="titles">套餐名称</el-col>
              <el-col :span="5" class="titles" v-if="active == 'groupCard'"><div class="goodName">商品名称</div></el-col>
              <el-col :span="4" class="titles center">剩余次数</el-col>
              <el-col :span="5" class="titles center">划卡次数</el-col>
              <el-col :span="3" class="titles right">操作</el-col>
            </el-row>
            <div class="tables p30 scroll-auto">
              <div
                class="boxs"
                v-for="(item, index) in listSelected"
                :key="index"
              >
                <el-row>
                  <el-col :span="active == 'groupCard' ? 6:11" class="titles">{{
                    item.cardName
                  }}</el-col>
                  <el-col :span="5" class="fb" v-if="active == 'groupCard'">
                    <div class="goodName fb">{{ item.itemName }}</div>
                  </el-col>
                  <el-col :span="4" class=" center">
                    <span v-if="active == 'groupCard'">{{item.orginNum - item.useNum}}</span>
                    <span v-else>{{item.leftCount}}</span>
                  </el-col>
                  <el-col :span="5" class="nums center fb fontSize18">
                    <span class="del-img" @click="blurItem('del',  item)">
                      <img src="../../../assets/images/new/del.png" alt="">
                    </span>
                    <el-input v-model="item.consumeNum" readonly="" size="mini" style="width: 40px;"></el-input>
                    <span class="del-img" @click="blurItem('add',item)">
                      <img src="../../../assets/images/new/add.png" alt="">
                    </span>
                  </el-col>
                  <el-col :span="3" class="detail right">
                    <i
                      class="el-icon-delete delete"
                      @click="deleteListSelected(item, index)"
                    ></i>
                  </el-col>
                </el-row>
                <div class="right-content p10">
                  <span class="color666 fontSize16 mr10">服务技师 :</span>
                  <span
                    v-if="item.staffIds.length == 0"
                    @click="setStaff(item, index)"
                    class="shopClass"
                    >请选择></span
                  >
                  <span
                    v-else
                    @click="setStaff(item, index)"
                    class="shopClass"
                    >{{ item.staffName }}</span
                  >
                </div>
              </div>
            </div>
            <div class="confirm-btn">
              <div class="flex-row space-between">
                <div class="msg">
                  <div class="nums total">
                    划卡数量:
                    <span>{{totalAmount}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
			  </div>
        <el-button class="save_btn" @click="saveMoney">确定划卡</el-button>
      </div>
      <!-- <div class="right-box">
        <div class="member-box">
          <member @handleChange="memberChange"></member>
        </div>
        <p class="shoping-titles">消费明细</p>
        <div class="contents-body">
          <el-row class="tables-title" v-if="active == 'groupCard'">
            <el-col :span="8" class="titles">套餐名称</el-col>
            <el-col :span="8" class="titles">商品名称</el-col>
            <el-col :span="4" class="titles center" style="text-align: center;">剩余次数</el-col>
            <el-col :span="4" class="titles center" style="text-align: center;">划卡次数</el-col>
          </el-row>
          <el-row class="tables-title" v-else>
            <el-col :span="8" class="titles">商品名称</el-col>
            <el-col :span="6" class="titles center" style="text-align: center;">剩余次数</el-col>
            <el-col :span="6" class="titles center" style="text-align: center;">划卡次数</el-col>
            <el-col :span="4" class="titles center" style="text-align: right;">删除</el-col>
          </el-row>
          <div class="tables scroll-auto" v-if="active == 'groupCard'">
            <div class="boxs" v-for="(item, index) in listSelected" :key="index">
              <el-row>
                <el-col :span="8" class="titles">{{ item.cardName }}</el-col>
                <el-col :span="8" class="titles">{{ item.itemName }}</el-col>
                <el-col :span="4" class="money center" style="text-align: center;">{{ item.orginNum - item.useNum}}</el-col>

                <el-col :span="4" class="nums center" style="text-align: center;">
                  <div class="align-items">
                        <div class="el-icon-remove-outline cur add-icons" @click="minus(item)"></div>
                        <div class="ml10 mr10 moneys">{{item.consumeNum}}</div>
                        <div class="el-icon-circle-plus-outline cur add-icons" @click="add(item)"></div>
                      </div>
                </el-col>
              </el-row>
              <div class="right-content p10">
               <span class="staff-btn mr10" >服务技师</span>
                <span v-if="item.staffIds.length == 0" @click="setStaff(item, index)" class="shopClass">请选择></span>
                <span v-else  @click="setStaff(item, index)" 	class="shopClass">{{item.staffName}}</span>
              </div>
            </div>
          </div>
          <div class="tables scroll-auto" v-else>
            <div class="boxs" v-for="(item, index) in listSelected" :key="index">
              <el-row>
                <el-col :span="8" class="titles">{{ item.cardName }}</el-col>
                <el-col :span="6" class="money center" style="text-align: center;">{{ item.leftCount }}</el-col>
                <el-col :span="6" class="nums center" style="text-align: center;">
                  <el-input-number v-model="item.consumeNum" @change="handleChangeNumber" @blur="blurItem(item)" :min="0" :max="item.leftCount"></el-input-number>
                </el-col>
                <el-col :span="4" class="detail center" style="text-align: right;">
                  <i class="el-icon-delete" @click="deleteListSelected(item, index)"></i>
                </el-col>
              </el-row>
              <div class="right-content p10">
               <span class="staff-btn mr10" >服务技师</span>
                <span v-if="item.staffIds.length == 0" @click="setStaff(item, index)" class="shopClass">请选择></span>
                <span v-else  @click="setStaff(item, index)" 	class="shopClass">{{staffName}}</span>
              </div>
            </div>
          </div>
          <div class="confirm-btn">
            <div class="flex-row space-between">
              <div class="msg">
                <div class="nums">
                  划卡次数:
                  <span style="color: red;">{{ totalAmount }}</span>
                </div>
              </div>
              <el-button type="primary" class="small-btn" @click="saveMoney">确定划卡</el-button>
            </div>
          </div>
        </div>
      </div> -->
      <div class="left-box">
        <el-tabs v-model="active" @tab-click="handleClick">
          <el-tab-pane v-for="(item,index) in allList" :key="index" :label="item.name" :name="item.cardType" ></el-tab-pane>
        </el-tabs>
        <div class="card-all box-active" :class="[allList.length > 0 ? 'listScoll' : '']" v-if="list.length > 0">
          <div class="title-tabs" v-if="active != 'groupCard'">
            <div class="card-box" v-for="(item, index) in list" :key="index" :class="index != 0 && (index + 1) % 2 == 0 ? 'notMargin' : ''">
              <div @click="handleChangeList(item, index)">
                <div class="card-msg active" >
                  <div class="fontSize18 fb">{{ item.cardName }}</div>
                  <div class="money fb itemPrice">{{ '￥'+item.saleAmount }}</div>
                  <div class="flex-row" style="color: #666;">
                    <p class="msg mr40">{{ item.validDay == -1 ? "永久有效" : '有效期至'+formatDay(item.validEndTime) }}</p>
                    <p>剩余<span class="money">{{ item.leftCount }}</span>次</p>
                  </div>
                  <div class="order-imgs" v-if="item.flag"><img src="../../../assets/images/new/memberCard_selected.png" alt=""></div>
                  <div class="order-vip"><img src="../../../assets/images/new/vip.png" alt=""></div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-tabs" v-else>
            <div v-for="(item) in list" :key="item.id">
              <p class="order-title-boxs mb10 mt0">
                <span class="blueBlock"></span><i>{{item.cardName}}</i>
              </p>
              <div class="card-tab-box">
                <div v-for="(k) in item.memberCardRightsList" :key="k.id" class="card-msg active" @click="minus(k)" :class="{'active-item':k.flag}">
                  <div class="flex-row space-between block">
                    <p><span v-if="k.rightsType == 'give'" class="card-tabs-give-img">[赠]</span>{{ k.itemName }}<span v-if="k.realFlag == 'disable'">(虚)</span></p>
                  </div>
                  <div class="space-between mt20">
                    <p class="moneys mr10">{{ '￥'+ k.itemPrice }}</p>
                    <p class="color666">剩余数量: &nbsp;&nbsp;{{k.orginNum - k.useNum}}</p>
                  </div>
                  <!-- <img src="../../../assets/images/new/payRadio.png" alt=""> -->
                  <div class="order-imgs" v-if="k.flag"><img src="../../../assets/images/new/payRadio.png" alt=""></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="temporarilyNoData empty">
            <img src="../../../assets/images/new/recharge.png" alt="">
            <div class="color999 fontSize16 mt20">暂无数据</div>
          </div>
        <div class="hint refund_box">
          <p class="infos">温馨提示</p>
          <p>1.套餐开卡，会员充值、修护卡开业务，请先注册成为我们的电子会员;</p>
          <p>2.办理点击会员后，每次凭密码或者验证码消费，交易安全有保障;</p>
        </div>
      </div>
      
    </div>
    <pay-form ref="payEditForm" @payFun="payMoney" :hintName="'划卡成功'" :foot="true"></pay-form>
    <staff-set ref="staffSetForm" :isCashier="true" @staffChange="changePage"></staff-set>
    <payDialog title="支付效验" :bizType="'cardReduce'" :hide="dialogHide" :memberId="form.memberId" :type="'paddleCard'" :num="totalAmount" :mobile="mobile" @changeDialog="dialogconfig"></payDialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import staffSet from "../../components/staff-set";
import member from "../../components/member";
import payForm from "../../components/pay";
import payDialog from "../../components/pay-dialog";
import { decrypt, encrypt } from "../../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: { staffSet, member, payDialog, payForm },
  data() {
    return {
      pageHeight: this.$store.getters.MainHeight,
      appInfo: this.$store.getters.AppInfo,
      codeName: true,
      time: 60,
      payHide: true,
      mainsHide: false,
      dialogHide: false,
      formMobile: '',
      successImg: require("../../../assets/images/money/success.png"),
      totalAmount: 0,
      img1: require("../../../assets/images/money/img1.png"),
      img2: require("../../../assets/images/money/img2.png"),
      img3: require("../../../assets/images/money/img3.png"),
      activeName: "serve",
      serveGoryName: "",
      staffName: "",
      serveGoryList: [], //服务分类
      list: [],
      productList: [],
      listSelected: [],
      form: {
        memberId: "",
        staffIds: "",
        memberCardId: "",
        consumeNum: 0,
        verifyCode: "",
        payCheckType: "tradePwd" // 'tradePwd': 密码,  'smsCode': 验证码
      },
      parmar: {
        memberId: "",
        verifyCode: "",
        payCheckType: "tradePwd",
        cardReduceItemList: [],
        millisecond: null,
        repeatToken: ""
      },
      childForm: {},
      orderId: "",
      allList: [],
      active: "",
      sourceFrom: '',
      mobile: ''
    };
  },

  created() {
    // this.serveList();
  },
  methods: {
    payMoney(org) {
      if (org) {
        this.listSelected = [];
        this.formMobile = "";
        this.$refs.memberSearch.handleInputHide();
      }
    },
    back() {
      this.$router.push("/collectMoney");
    },
    handleTabs() {
      this.form.verifyCode = "";
    },
       // 失去焦点的时候 数量变为1
    blurItem(type,item) {
      console.log(item);
      if  (!item.leftCount && item.leftCount != 0) {
        if (type == 'del') {
        if (item.consumeNum > 0) {
          item.consumeNum--;
          this.totalAmount--;
          };
        } else {
          console.log(item.consumeNum,item.orginNum - item.useNum);
          if (item.consumeNum >= (item.orginNum - item.useNum)) return
          item.consumeNum++;
          this.totalAmount++;
        }
      } else {
        if (type == 'del') {
          if (item.consumeNum > 0) {
            item.consumeNum--;
            this.totalAmount--;
          };
        } else {
          if (item.consumeNum >= item.leftCount) return
          item.consumeNum++;
          this.totalAmount++;
        }
      }
      
		},
    dialogclose() {
      this.dialogHide = false;
    },
    dialogconfig(org) {
      if (org != "") {
        if (this.active == 'groupCard') {
          this.parmar.payCheckType = org.payCheckType;
          this.parmar.verifyCode = org.verifyCode;
          this.parmar.millisecond = new Date().getTime();
          this.$api.post(this.$url.order.groupCardReduce, encrypt(JSON.stringify(this.parmar))).then(res => {
              if (res) {
                this.dialogHide = false;
                this.$refs["payEditForm"].$emit("set", res);
              } else {
                this.$api.get(this.$url.order.getToken).then(res => {
                  if (res) {
                    this.parmar.repeatToken = res;
                  }
                })
                this.dialogHide = true;
                this.payHide = true;
              }
          })
        } else {
          console.log(this.form);
          this.form.payCheckType = org.payCheckType;
          this.form.verifyCode = org.verifyCode;
          this.form.millisecond = new Date().getTime();
          this.$api.post(this.$url.order.cardReduce, encrypt(JSON.stringify(this.form))).then(res => {
              if (res) {
                this.dialogHide = false;
                this.$refs["payEditForm"].$emit("set", res);
              } else {
                this.$api.get(this.$url.order.getToken).then(res => {
                  if (res) {
                    this.form.repeatToken = res;
                  }
                })
                this.dialogHide = true;
                this.payHide = true;
              }
          })
        }
      } else {
        this.dialogHide = false;
      }
    },
    memberChange(value) {
      this.form.memberId = value.id;
      this.mobile = value.mobile;
      if (value) {
        this.serveList(this.form.memberId);
      }
      this.list = [];
      this.listSelected = [];
      this.allList = [];
      this.totalAmount = 0;
    },
    handleChangeList(item) {
      this.listSelected = [];
      this.list.map(it => {
        it.flag = false;
      })
      item.flag = true;
      item.consumeNum = 0;
      this.totalAmount = 0;
      console.log(item);
      this.listSelected.push(JSON.parse(JSON.stringify(item)));
    },
    handleChange(item) {
      // item.flag = !item.flag;
      if (this.listSelected.length > 0) {
        this.listSelected.map((k,index) => {
          if (k.id === item.id) {
            item.flag = !item.flag;
            k.flag = item.flag;
          } else if (k.id !== item.id) {
            item.flag = !item.flag;
            this.listSelected.push(JSON.parse(JSON.stringify(item)));
          }
          if (!k.flag) {
            this.listSelected.splice(index, 1)
          } 
        })
      } else {
        item.flag = !item.flag;
        this.listSelected.push(JSON.parse(JSON.stringify(item)));
      }
      item.consumeNum = 0;
      this.totalAmount = 0;
      
    },
    deleteListSelected (item, index) {
      item.flag = false;
      this.listSelected.splice(index, 1);
      this.totalAmount = this.totalAmount - item.consumeNum;
      item.consumeNum = 0;
    },
    setStaff(row, index) {
      console.log(row, this.cardType);
      if (this.active == 'groupCard' && row.consumeNum == 0) {
        return this.$message.error("请选择划卡数量")
      }
      this.$refs["staffSetForm"].$emit("set", {
        staffIds: row.staffIds,
        index: index
      });
    },
    changePage(org) {
      console.log(org);
      if (org.staffIds) {
        let arr = []
        org.staffIds.map(item => {
          arr.push(item.staffName)
        })
        this.staffName = arr.join(",") + ">";
        this.$set(this.listSelected[org.nodeId], "staffIds", org.staffIds);
        this.$set(this.listSelected[org.nodeId], "staffName", this.staffName);
        console.log(this.listSelected, 'this.listSelected');
      }
    },
    minus (item) {
      // 选择
      if (item.orginNum == item.useNum) return 
      item.flag = !item.flag;
      if (item.flag) {
        this.listSelected.push(item);
      } else {
        this.listSelected.map((i,index) => {
          if (i.id == item.id) {
            // this.listSelected.splice(index, 1);
            this.deleteListSelected(i, index)
          }
        })
      }
    },
    saveMoney() {
      if (!this.form.memberId) {
        this.$message.warning("请选择会员");
        return false;
      }
      if (this.listSelected.length < 1) {
        this.$message.warning("请添加消费");
        return false;
      }
      if (this.totalAmount == 0) {
        return this.$message.warning("划卡次数不能为0次");
      }
      for (let i in this.listSelected) {
        if (this.listSelected[i].staffIds.length < 1) {
          this.$message.warning(this.listSelected[i].cardName + " 请选择技师");
          return false;
        }
      }
      
      let arrIds = "",
        arrNames = "";
      if (this.active != 'groupCard') {
        for (let i in this.listSelected) {
          for (let j in this.listSelected[i].staffIds) {

            console.log(this.listSelected[i].staffIds instanceof Array , '------------');
            if (this.listSelected[i].staffIds instanceof Array) {
              if (j == 0) {
                arrIds = this.listSelected[i].staffIds[j].staffId;
                arrNames = this.listSelected[i].staffIds[j].staffName;
              } else {
                arrIds += "," + this.listSelected[i].staffIds[j].staffId;
                arrNames += "," + this.listSelected[i].staffIds[j].staffName;
              }
            } else {
              arrIds = this.listSelected[i].staffIds;
              arrNames = this.listSelected[i].staffNames;
            }
          }
        }
      }
      if (this.active == 'groupCard') {
        this.parmar.memberId = this.form.memberId;
        this.parmar.cardReduceItemList = this.listSelected;
        for (let i in this.parmar.cardReduceItemList) {
          for (let j in this.parmar.cardReduceItemList[i].staffIds) {
            if (this.listSelected[i].staffIds instanceof Array) {
              if (j == 0) {
                arrIds = this.listSelected[i].staffIds[j].staffId;
                arrNames = this.listSelected[i].staffIds[j].staffName;
              } else {
                arrIds += "," + this.listSelected[i].staffIds[j].staffId;
                arrNames += "," + this.listSelected[i].staffIds[j].staffName;
              }
            } else {
              arrIds = this.listSelected[i].staffIds;
              arrNames = this.listSelected[i].staffNames;
            }
          }
          this.parmar.cardReduceItemList[i].staffIds = arrIds;
          this.parmar.cardReduceItemList[i].staffNames = arrNames;
        }
      } else {
        this.form.staffIds = arrIds;
        this.form.staffNames = arrNames;
        this.form.consumeNum = this.listSelected[0].consumeNum;
        this.form.memberCardId = this.listSelected[0].id;
        this.form.sourceFrom = this.listSelected[0].sourceFrom;
      }
      localStorage.setItem("productType", "stamp");
      this.$api.get(this.$url.order.getToken).then(res => {
        if (res) {
          if (this.active == 'groupCard') {
            this.parmar.repeatToken = res;
          } else {
            this.form.repeatToken = res;
          }  
          this.dialogHide = true;
        }
      })
    },
    serveList(id) {
      this.$api.get(this.$url.memberCard.listByCateTree, { memberId: id ? id : '""' }).then(res => {
          if (res) {
            this.list = res[0].cardList;
            this.allList = res;
            if (res.length > 0) {
              this.active = res[0].cardType;
            }
            if (res[0].cardType == 'groupCard') {
              for (let i in this.list) {
                console.log(this.list[i]);
                for (let y in this.list[i].memberCardRightsList) {
                  this.$set(this.list[i].memberCardRightsList[y], "staffIds", []);
                  this.$set(this.list[i].memberCardRightsList[y], "flag", false);
                  this.$set(this.list[i].memberCardRightsList[y], "cardName", this.list[i].cardName);
                  this.$set(this.list[i].memberCardRightsList[y], "consumeNum", 0);
                }
              }
            } else {
              for (let i in this.list) {
                this.$set(this.list[i], "staffIds", []);
              }
            }
          }
        });
    },
    handleClick (item) {
      this.listSelected = [];
      this.active = item.name;
      this.totalAmount = 0;
      if (item.index == 0) {
        this.list = this.allList[0].cardList || [];
        for (let i in this.list) {
          this.$set(this.list[i], "staffIds", []);
          this.$set(this.list[i], "flag", false);
        }
      } else if (item.name == 'groupCard') {
        this.list = this.allList[1].cardList || [];
        for (let i in this.list) {
          console.log(this.list[i]);
          for (let y in this.list[i].memberCardRightsList) {
            this.$set(this.list[i].memberCardRightsList[y], "staffIds", []);
            this.$set(this.list[i].memberCardRightsList[y], "flag", false);
            this.$set(this.list[i].memberCardRightsList[y], "cardName", this.list[i].cardName);
            this.$set(this.list[i].memberCardRightsList[y], "consumeNum", 0);
          }
        }
      } else if (item.index == 2) {
        this.list = this.allList[2].cardList || [];
        for (let i in this.list) {
          this.$set(this.list[i], "staffIds", []);
          this.$set(this.list[i], "flag", false);
        }
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.mains-content {
  display: flex;
  height: 100%;
  .left-box {
    width: 60%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .card-all {
      padding: 0 16px;
     
      height: 100%;
      .title-tabs {
         display: flex;
        flex-wrap: wrap;
        
        
        
        
        // background: url("../../../assets/images/new/vip.png") no-repeat;
      }
      .card-tabs {
        .card-tab-box {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding: 0 16px;
          .card-msg {
            position: relative;
            width: calc(49% - 32px);
            margin: 5px 0;
            background: #F7F8FA;
            border: 1px solid #F7F8FA;
            border-radius: 4px;
            padding: 16px;
            
          }
        }
        .active-item {
          border: 1px solid #3388FF !important;
        }
      }
    }
    .card-box {
      position: relative;
      width: calc(49% - 32px);
      padding: 16px;
      margin-bottom: 20px;
      background-color: #fff6ec;
      border-radius: 4px;
      margin-right: 2%;
      &:nth-of-type(2n) {
        margin-right: 0 !important;
      }
      .card-msg {
        color: #fff;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .itemPrice {
          margin: 30px 0 10px;
        }
      }
      .active {
        color: #333;
        .money {
          color: @money;
        }
      }
    }
    .notMargin {
      margin-right: 0;
    }
  }
}
  .refund_box {
      border-radius: 10px;
      padding: 10px;
      margin-top: 10px;
      p {
        padding-top: 5px;
      }
      .infos {
        // color: #ff892a;
        color: #111;
        padding-bottom: 5px;
      }
  }
  .hint {
    margin: 0 20px;
    color: #999;
    background: #FBFBFC;
    border: 1px solid #E5E5E5;
    border-radius: 4px;
  }
  .box-active {
    overflow: auto;
    height: calc(100vh - 225px) !important;
  }
  .listScoll {
    height: calc(100vh - 265px) !important;
  }
  .add-icons {
    font-size: 20px;
  }

.collect-card {
  height: calc(100vh - 58px);
  background-color: #e6edf5;
  padding: 16px;
  .groupDialog /deep/ .el-dialog__body {
    padding: 10px 20px;
    color: #111;
    height: 200px;
    overflow: auto;
  }
}

 .member-box {
    width: calc(100% - 48px);
    padding: 15px 16px;
    background: #3388ff;
    border-radius: 10px 10px 0px 0px;
	}
  .right-box {
		background: url("../../../assets/images/new/footBath.png") no-repeat;
    background-position:center bottom;
    height: calc(100vh - 248px);
    margin-right: 16px;
		.right-box-empty {
      height: calc(100vh - 248px);
      display: flex;
      justify-content: center;
      align-items: center;
      .right-box-empty-img {
        width: 191px;
        height: 170px;
      }
    }
		.shoping-titles {
			padding: 16px;
			font-size: 18px;
			font-weight: 700;
		}
		.contents-body {
			.tables-title {
        font-size: 14px;
        padding: 13px 16px;
        background: #F7F8FA;
			}
			.tables {
				padding: 0 0 16px;
				height: calc(100vh - 430px);
				box-sizing: border-box;
				.boxs {
					padding: 18px 16px 0;
					box-sizing: border-box;
					.money {
						color: @money;
						font-weight: 500;
					}
					.delete {
						font-size: 18px;
						cursor: pointer;
						&:hover {
							color: @blue;
						}
					}
				}
				.right-content {
					margin-top: 15px;
					display: flex;
          padding-bottom: 16px;
          border-bottom: 1px solid #EBEDF0;
				}
			}
      
			.confirm-btn {
				display: flex;
				align-items: center;
				margin: 0 16px;
				border-top: 1px solid #EBEDF0;
				padding: 12px 0;
				.flex-row {
					width: 100%;
					align-items: center;
          
					.msg {
            width: 100%;
						display: flex;
            justify-content: flex-end;
						font-weight: 500;
						.nums {
              line-height: 3;
							margin-right: 40px;
						}
					}
				}
			}
      
		}
    
	}
/deep/ .el-tabs__nav-wrap {
  padding: 0 16px;
  .el-tabs__item {
    height: 48px;
    line-height: 48px;
    font-size: 18px;
  }
}
/deep/ .el-dialog__header {
  border-bottom: 1px solid #F5F5F5;
}
.page-left {
  width: 40%;
}
.box-actives {
  border: 1px solid #F9AA6C !important;
}
.save_btn {
  width: calc(100% - 16px);
  height: 68px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;
  color: #fff;
  background: #FF5449;
}
.goodName {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.nums {
  display: flex;
  justify-content: center;
  .del-img {
    width: 28px;
    height: 28px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  /deep/ .el-input__inner {
    border-radius: inherit;
    text-align: center;
    padding: 0;
    border-left: none;
    border-right: none;
  }
}
.order-imgs {
  width: 30px;
  height: 30px;
  position: absolute;
  right: 0;
  top: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
.order-vip {
  width: 60%;
  position: absolute;
  right: 0;
  bottom: 0;
  img {
    width: 100%;
    height: 100%;
  }
}
.empty {
  height: calc(100vh - 228px);
}
</style>
